<template>
        <div style="margin: 0px; padding: 0px;">
                <v-cookie></v-cookie>
                <span style="width: 500px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
                    秒杀成功,开通号码请联系客服提供资料。<br/><br/>
                    <el-button type="text" @click="close()"><span style="font-size:16px;">关闭页面</span></el-button>
                    <el-button type="text" @click="goKeFu()"><span style="font-size:16px;">联系客服</span></el-button>
                    <el-button type="text" @click="qryseconds400activity()"><span style="font-size:16px;">查看我秒杀的400号码</span></el-button>
                </span>
        </div>
    </template>
    <script>
    import cookie from '@/components/cookie.vue'
    export default {
        components : {
            'v-cookie' : cookie,
        },
        methods:{
            close(){
                window.close();
            },
            qryseconds400activity() {
                this.$router.push("/seconds400activityrecord");
            },
            goKeFu() {
                this.$router.push("/kefuindex");
            }
        }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/seconds400paysuccess.vue